<!-- INITIAL MESSAGE -->
<ion-row [ngClass]="{ desktop: isDesktop, tablet: isTablet, mobile: isMobile }">
  <ion-col size="12">
    <h2 data-cy="image-order-welcome-header">
      {{ 'i18n.imageOrderingPage.welcomeMessage' | translate }}
    </h2>
  </ion-col>
</ion-row>

<ion-row>
  <ion-col size="12">
    <p data-cy="image-order-welcome-description">
      {{ 'i18n.imageOrderingPage.createOrderMessage' | translate }}
    </p>
    <p
      [innerHtml]="'i18n.imageOrderingPage.pdfMessage' | translate"
      data-cy="image-order-pdf-message-text"
    ></p>
  </ion-col>
</ion-row>

<ion-row
  [ngClass]="{ desktop: isDesktop, tablet: isTablet, mobile: isMobile }"
  *ngIf="showButtons"
>
  <ion-col>
    <ng-container *ngIf="isDesktop; else mobileButtons">
      <!-- UPLOAD-FILE BUTTON -->
      <ion-button
        data-cy="image-order-upload-button"
        class="btn-upload usf-fill-green-button"
        [ngClass]="{ 'btn-full': isMobile }"
        (click)="uploadFileOptionEmitter.emit()"
      >
        &nbsp;<ion-icon name="cloud-upload"></ion-icon>&nbsp;
        {{ 'i18n.imageOrderingPage.uploadFile' | translate }}&nbsp;
      </ion-button>

      <!-- CAMERA BUTTON -->
      <ion-button
        data-cy="image-order-camera-button"
        class="btn-camera usf-green-link-button"
        [ngClass]="{ 'btn-full': isMobile }"
        [disabled]="!hasCameraAccess"
        (click)="cameraOptionEmitter.emit()"
      >
        &nbsp;<ion-icon name="camera"></ion-icon>&nbsp;
        {{ 'i18n.imageOrderingPage.camera' | translate }}&nbsp;
      </ion-button>
    </ng-container>

    <ng-template #mobileButtons>
      <!-- CAMERA BUTTON -->
      <ion-button
        data-cy="image-order-camera-button"
        class="btn-camera usf-fill-green-button"
        [ngClass]="{ 'btn-full': isMobile }"
        [disabled]="!hasCameraAccess"
        (click)="cameraOptionEmitter.emit()"
      >
        &nbsp;<ion-icon name="camera"></ion-icon>&nbsp;
        {{ 'i18n.imageOrderingPage.camera' | translate }}&nbsp;
      </ion-button>

      <!-- UPLOAD-FILE BUTTON -->
      <ion-button
        data-cy="image-order-upload-button"
        class="btn-upload usf-green-link-button"
        [ngClass]="{ 'btn-full': isMobile }"
        (click)="uploadFileOptionEmitter.emit()"
      >
        &nbsp;<ion-icon name="cloud-upload"></ion-icon>&nbsp;
        {{ 'i18n.imageOrderingPage.uploadFile' | translate }}&nbsp;
      </ion-button>
    </ng-template>
  </ion-col>
</ion-row>
